import axios from "axios";

// API de chamados do InovaSupport (inovaSup_API).
// Em produção, defina VITE_CHAMADOS_API no build (ex.: https://api-inovasupport.inovacode.app.br/).
const chamados_api = axios.create({
  baseURL: import.meta.env.VITE_CHAMADOS_API || "http://localhost:3001",
});

export default chamados_api;
